export enum Frequency {
    ONCE = "once",
    DAILY = "daily",
    MONTHLY = "monthly",
    YEARLY = "yearly",
}